import { useUser } from "./useUser";

export const usePermissions = () => {
  const [user, _, hasPermission] = useUser();

  const any = (keys: string[], chatId?: string, orgId?: string) => {
    return keys.some(key => hasPermission(key, chatId, orgId));
  }

  const all = (keys: string[], chatId?: string, orgId?: string) => {
    return keys.every(key => hasPermission(key, chatId, orgId));
  }

  return { user, has: hasPermission, any, all } as const;
}
